import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Changes.Vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Changes.Vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Changes.Vue?vue&type=script&lang=js
// module id = 31
// module chunks = 0